"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, $, undefined) {
  "use strict";

  var GunnerApp = {
    name: "GunnerApp",
    // this init is not really being used, probably redundant.
    init: function init(plugins) {
      plugins.forEach(function (plugin) {
        var _this = $(this);
        GunnerApp[plugin].call(_this);
      });
    },
    Menu: function Menu(_this) {
      var menuplugin = new _Menu(_this);
      menuplugin;
    },
    Gallery: function Gallery(_this, options) {
      var galleryplugin = new _Gallery(_this, options);
      galleryplugin;
    },
    ClassOnScroll: function ClassOnScroll(_this, options) {
      var scrollplugin = new _ClassOnScroll(_this, options);
      scrollplugin;
    },
    ScrollOnClick: function ScrollOnClick(_this, options) {
      var scrollplugin = new _ScrollOnClick(_this, options);
      scrollplugin;
    },
    Filters: function Filters(_this) {
      var filtersplugin = new _Filters(_this);
      filtersplugin;
    },
    CategoryFilter: function CategoryFilter(_this) {
      var categoryfilterplugin = new _CategoryFilter(_this);
      categoryfilterplugin;
    },
    Accordion: function Accordion(_this) {
      var accordionplugin = new _Accordion(_this);
      accordionplugin;
    },
    Donation: function Donation(_this) {
      var donateplugin = new _Donation(_this);
      donateplugin;
    }
  };

  var _Accordion = function () {
    function _Accordion(element) {
      _classCallCheck(this, _Accordion);

      this.element = element;
      this._init();
    }

    _createClass(_Accordion, [{
      key: "_init",
      value: function _init() {
        var _this = this;
        var _panels = $(this.element).find('.js-accordion-panel');

        _panels.each(function () {
          var link = $(this).find('.js-accordion-toggle');

          link.on('click', function (e) {
            e.preventDefault();
            var parent = link.parent();
            if (!parent.hasClass('is-active')) {
              _panels.removeClass('is-active');
              parent.addClass('is-active');
            }
          });
        });
      }
    }]);

    return _Accordion;
  }();

  var _Menu = function () {
    function _Menu(element, options) {
      _classCallCheck(this, _Menu);

      this.element = element;
      this._init();
      this.body = $('body');
    }

    _createClass(_Menu, [{
      key: "_init",
      value: function _init() {
        var activeClass = 'menu-is-active';
        var navToggle = $(this.element);
        var _this = this;

        navToggle.on('click', function (e) {
          e.preventDefault();
          _this._toggle(activeClass);
        });
      }
    }, {
      key: "_toggle",
      value: function _toggle(activeClass) {
        var _this = this;
        if (this.body.hasClass(activeClass)) {
          _this._closeNav(activeClass);
        } else {
          _this._openNav(activeClass);
        }
      }
    }, {
      key: "_openNav",
      value: function _openNav(activeClass) {
        this.body.addClass(activeClass);
      }
    }, {
      key: "_closeNav",
      value: function _closeNav(activeClass) {
        this.body.removeClass(activeClass);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        // don't think this is needed
      }
    }]);

    return _Menu;
  }();

  // Gallery depends on Slick. We could just init Slick on page load but this way makes things a bit...Slicker. //

  var _Gallery = function () {
    function _Gallery(element, options) {
      _classCallCheck(this, _Gallery);

      this.element = element;
      this.options = $.extend({}, _Gallery.defaults, options);
      this.body = $('body');
      this.slider = $(this.element).find(".js-slider");
      this._init();
    }

    _createClass(_Gallery, [{
      key: "_init",
      value: function _init() {
        var activeClass = 'gallery-is-active';
        var galleryToggle = $('.js-gallery-toggle');
        var _this = this;

        galleryToggle.on('click', function () {
          _this._toggle(activeClass);
        });

        galleryToggle.keypress(function (e) {
          if (e.which === 32) {
            //e.preventDefault();
            //_this._toggle(activeClass);
          }
        });

        $(document).on('keydown', function (e) {
          if (e.keyCode == 37) {
            $(this.slider).slick('slickPrev');
          }
          if (e.keyCode == 39) {
            $(this.slider).slick('slickNext');
          }
          if (e.which === 32) {
            //e.preventDefault();
            //_this._toggle(activeClass);
          }
        });

        $(this.slider).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          dots: false,
          speed: 500
        });
      }
    }, {
      key: "_toggle",
      value: function _toggle(activeClass) {
        var _this = this;
        if (this.body.hasClass(activeClass)) {
          _this._closeGallery(activeClass);
        } else {
          _this._openGallery(activeClass);
        }
      }
    }, {
      key: "_openGallery",
      value: function _openGallery(activeClass) {
        setTimeout(function () {
          $(document).find('.slick-list').attr('tabindex', 0).focus();
        }, 500);

        this.body.addClass(activeClass);
        $(window).trigger('resize');
        $(this.slider).resize();
        $(this.slider).slick('setDimensions');
        $(this.slider).slick('getSlick').refresh();
        var SlideWidth = $(document).find('.slick-slide').outerWidth();
        console.log('first' + SlideWidth);
      }
    }, {
      key: "_closeGallery",
      value: function _closeGallery(activeClass) {
        this.body.removeClass(activeClass);
      }
    }]);

    return _Gallery;
  }();

  _Gallery.defaults = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    dots: false,
    speed: 500
  };

  var _ClassOnScroll = function () {
    function _ClassOnScroll(element, options) {
      _classCallCheck(this, _ClassOnScroll);

      this.element = $(element);
      var opt = this.element.attr('data-gunner-options');
      if (opt) {
        opt = opt.split(',').reduce(function (acc, cur) {
          var data = cur.split(':');
          acc[data[0]] = data[1];
          return acc;
        }, {});
      }
      this.options = $.extend({}, _ClassOnScroll.defaults, opt);
      this._init();
    }

    _createClass(_ClassOnScroll, [{
      key: "_init",
      value: function _init() {
        var _this = this;
        var _window = $(window);
        var _offset = this.options.offset;
        var _activeclass = this.options.activeclass;

        // we might want the offset to be based off another element
        if (this.options.reference) {
          var _reference = this.options.reference;
          if ($(_reference).length > 0) {
            _offset = $(_reference).outerHeight() - this.element.outerHeight() * 2;
          }
        }

        var trigger = throttle(function () {
          var scroll = _window.scrollTop();
          if (scroll >= _offset) {
            _this._AddClassonScroll(_activeclass);
          } else {
            _this._RemoveClassonScroll(_activeclass);
          }
        }, 50);

        _window.scroll(function () {
          trigger();
        });
      }
    }, {
      key: "_AddClassonScroll",
      value: function _AddClassonScroll(_activeclass) {
        this.element.addClass(_activeclass);
      }
    }, {
      key: "_RemoveClassonScroll",
      value: function _RemoveClassonScroll(_activeclass) {
        this.element.removeClass(_activeclass);
      }
    }]);

    return _ClassOnScroll;
  }();

  _ClassOnScroll.defaults = {
    offset: 500,
    activeclass: 'element-in-view'
  };

  var _ScrollOnClick = function () {
    function _ScrollOnClick(element) {
      _classCallCheck(this, _ScrollOnClick);

      this.element = $(element);
      this._init();
    }

    _createClass(_ScrollOnClick, [{
      key: "_init",
      value: function _init() {
        var _this = this,
            hero = $('.hero'),
            button = this.element;

        button.click(function (e) {
          e.preventDefault();

          var targetName = button.data('target');
          var scrollTarget = 0;

          // 120 is height of header bar at largest size
          if (targetName == 'content') {
            scrollTarget = hero.height() - 120;
          }

          $('html, body').animate({
            scrollTop: scrollTarget + "px"
          }, 600);
        });
      }
    }]);

    return _ScrollOnClick;
  }();

  var _Filters = function () {
    function _Filters(element, options) {
      _classCallCheck(this, _Filters);

      this.element = element;
      this.options = $.extend({}, _Filters.defaults, options);
      this._init();
    }

    _createClass(_Filters, [{
      key: "_init",
      value: function _init() {
        var _this = this;
        var filterElement = $(this.element).attr('data-filter-element');
        var parent = $(this.element);
        var filtered = {};
        var joined = '';

        // console.log(joined);

        $('.filters__list').each(function () {
          var $this = $(this);
          var $type = $this.data('filter-type');
          filtered[$type] = 'all' || {};
          joined = Object.keys(filtered).reduce(function (acc, filter) {
            acc.push(filter + '-' + filtered[filter]);
            return acc;
          }, []);
        });

        // console.log(joined);

        $('.filters__list').on('change', function (e) {
          var $this = $(this);
          var $val = $this.val();
          var $type = $this.data('filter-type');
          var minCount = parent.find('select').length;

          filtered[$type] = $val || {};

          joined = Object.keys(filtered).reduce(function (acc, filter) {
            acc.push(filter + '-' + filtered[filter]);
            return acc;
          }, []);

          // console.log(joined);

          var path = '?filter=' + joined;
          history.pushState(path, "page 2", path);

          $('.' + filterElement).find('li').each(function (index, list) {
            var hasAllClasses = joined.every(function (item) {
              return list.classList.contains(item);
            }) && joined.length === minCount;

            if (hasAllClasses) {
              // console.log('yes');
              list.classList.remove('is-hidden');
              list.classList.add('active');
            } else {
              // console.log(joined);
              list.classList.remove('active');
              list.classList.add('is-hidden');
            }
          });
        });
      }
    }]);

    return _Filters;
  }();

  _Filters.defaults = {};

  var _CategoryFilter = function () {
    function _CategoryFilter(element, options) {
      _classCallCheck(this, _CategoryFilter);

      this.element = element;
      this._init();
    }

    _createClass(_CategoryFilter, [{
      key: "_init",
      value: function _init() {
        var _this = this;
        var _dropdown = $(this.element).find('select');

        $(_dropdown).on('change', function (e) {
          _this._onCatChange(_dropdown);
        });
      }
    }, {
      key: "_onCatChange",
      value: function _onCatChange(_dropdown) {
        location.href = $(_dropdown).val();
      }
    }]);

    return _CategoryFilter;
  }();

  var _Donation = function () {
    function _Donation(element, options) {
      _classCallCheck(this, _Donation);

      this.element = element;
      this.donation = { 'currency': 'GBP', 'type': 'oneoff', 'amount': '0.00', 'payment_method': '' };
      this.chequeSpelling = "Cheque";
      this.isBoundPaymentSubmit = false;
      this._init();
    }

    _createClass(_Donation, [{
      key: "_init",
      value: function _init() {
        var _this = this,
            _onetimeAmount = $(_this.element).find('.js-onetime-amount'),
            _recurringtimeAmount = $(_this.element).find('.js-recurring-amount'),
            _donateMethod = $(_this.element).find('.js-donate-method'),
            giftAidFields = $('.js-gift-aid-fields');

        _onetimeAmount.on("click", function () {
          $(_this.element).find('.donation__input').removeClass('deselected');
          $(_this.element).find('.js-recurring-amount').removeClass('selected');
        });

        _onetimeAmount.on("blur", function () {
          _this.donation.amount = $(this).val();
          $('.payment-amount-hidden').val($(this).val());
          _this.donation.currency = $(this).attr('data-currency');
          _this.donation.type = 'oneoff';
          _this._validation();
        });

        $('.donation__amount--other').on("blur", function () {
          _this.donation.amount = $(this).val();
          $('.payment-amount-hidden').val($(this).val());
          _this.donation.currency = $(this).attr('data-currency');
          _this.donation.type = 'recurring';
          _this._validation();
        });

        _recurringtimeAmount.on("click", function () {
          $(_this.element).find('.js-recurring-amount').removeClass('selected');
          $(_this.element).find('.donation__input').addClass('deselected');
          $(this).addClass('selected');
          _this.donation.amount = $(this).attr('data-amount');
          _this.donation.currency = $(this).attr('data-currency');
          _this.donation.type = 'recurring';
          _this._validation();
        });

        _donateMethod.on("click", function () {
          _this.donation.payment_method = $(this).attr('id');
          giftAidFields.hide().attr('aria-hidden', 'true').find('.js-toggle-required').removeClass('required');
          _this._validation();

          // reset gift aid radios
          $('.js-gift-aid-show').prop('checked', false);
          $('.js-gift-aid-hide').prop('checked', false);
        });

        // change spelling of 'cheque/check' - show/hide gift aid
        $('a[href="#unitedstates"]').click(function () {
          $('.js-spelling-upper').text('Check');
          $('.js-spelling-lower').text('check');
          $('.js-gift-aid-buttons, .js-gift-aid-fields').hide().attr('aria-hidden', 'true');
          $('.payment-location-hidden').val('United States');

          $('.js-unitedkingdom-title').hide();
          $('.js-usa-title').show();
        });

        $('a[href="#unitedkingdom"]').click(function () {
          $('.js-spelling-upper').text('Cheque');
          $('.js-spelling-lower').text('cheque');
          $('.js-gift-aid-buttons').show().attr('aria-hidden', 'false');
          $('.payment-location-hidden').val('UK and rest of world');
          $('.js-unitedkingdom-title').show();
          $('.js-usa-title').hide();
        });

        _this._tabs();

        // show/hide gift aid extra fields
        $('.js-gift-aid-show').click(function () {
          giftAidFields.show().attr('aria-hidden', 'false').find('.js-toggle-required').addClass('required');
          $('.giftaid__hidden').val('yes');
        });

        $('.js-gift-aid-hide').click(function () {
          giftAidFields.hide().attr('aria-hidden', 'true').find('.js-toggle-required').removeClass('required');
          $('.giftaid__hidden').val('no');
        });

        // when recurring buttons clicked
        $('.donation__tabcontent--type-recurring').click(function () {
          // hide cheque/wire transfer options
          // hide any previously showing forms
          // show relevant paypal form
          var formClassName = $(this).data('form'),
              radioId = $(this).data('radio');

          $('.js-recurring-hide').hide().attr('aria-hidden', 'true');
          $('.wiretransfer, .js-payment-method').hide().attr('aria-hidden', 'true');
          $("." + formClassName).show().attr('aria-hidden', 'false');
          $("#" + radioId).trigger("click");
        });

        // when one-time donation input clicked
        $('.js-one-time-show').click(function () {
          // show cheque/wire transfer options and recurring paypal forms
          $('.js-recurring-hide').show().attr('aria-hidden', 'false');
          $(".js-recurring-paypal, .js-recurring-paypal-us").hide().attr('aria-hidden', 'true');
          $('#UK_PayPal, #US_PayPal').prop('checked', false);
        });
      }
    }, {
      key: "_tabs",
      value: function _tabs() {
        // The class for the container div

        var $container = '.js-tabs';

        // The setup

        $($container + ' ul').attr('role', 'tablist');
        $($container + ' [role="tablist"] li').attr('role', 'presentation');
        $('[role="tablist"] a').attr({
          'role': 'tab',
          'tabindex': '-1'
        });

        // Make each aria-controls correspond id of targeted section (re href)

        $('[role="tablist"] a').each(function () {
          $(this).attr('aria-controls', $(this).attr('href').substring(1));
        });

        // Make the first tab selected by default and allow it focus

        $('[role="tablist"] li:first-child a').attr({
          'aria-selected': 'true',
          'tabindex': '0'
        });

        // Make each section focusable and give it the tabpanel role

        $($container + ' section').attr({
          'role': 'tabpanel'
        });

        // Make first child of each panel focusable programmatically

        $($container + ' section > *:first-child').attr({
          'tabindex': '0'
        });

        // Make all but the first section hidden (ARIA state and display CSS)

        $('[role="tabpanel"]:not(:first-of-type)').attr({
          'aria-hidden': 'true'
        });

        // Change focus between tabs with arrow keys

        $('[role="tab"]').on('keydown', function (e) {

          // define current, previous and next (possible) tabs

          var $original = $(this);
          var $prev = $(this).parents('li').prev().children('[role="tab"]');
          var $next = $(this).parents('li').next().children('[role="tab"]');
          var $target;

          // find the direction (prev or next)

          switch (e.keyCode) {
            case 37:
              $target = $prev;
              break;
            case 39:
              $target = $next;
              break;
            default:
              $target = false;
              break;
          }

          if ($target.length) {
            $original.attr({
              'tabindex': '-1',
              'aria-selected': null
            });
            $target.attr({
              'tabindex': '0',
              'aria-selected': true
            }).focus();
          }

          // Hide panels

          $($container + ' [role="tabpanel"]').attr('aria-hidden', 'true');

          // Show panel which corresponds to target

          $('#' + $(document.activeElement).attr('href').substring(1)).attr('aria-hidden', null);
        });

        // Handle click on tab to show + focus tabpanel

        $('[role="tab"]').on('click', function (e) {

          e.preventDefault();

          // remove focusability [sic] and aria-selected

          $('[role="tab"]').attr({
            'tabindex': '-1',
            'aria-selected': null
          });

          // replace above on clicked tab

          $(this).attr({
            'aria-selected': true,
            'tabindex': '0'
          });

          // Hide panels

          $($container + ' [role="tabpanel"]').attr('aria-hidden', 'true');

          // show corresponding panel

          $('#' + $(this).attr('href').substring(1)).attr('aria-hidden', null);
        });
      }
    }, {
      key: "_validation",
      value: function _validation(type) {
        var _this = this;
        var _valid = true;
        var _error_messages = [];

        // make sure success message is hidden
        $('.donation__success').css('display', 'none').attr('aria-hidden', 'true');

        $('.js-donation-payment').removeClass('selected');
        $('.js-payment-amount').val(this.donation.amount);
        $('.js-error').empty().removeClass('on').attr('role', null);

        if (_this.donation.type === 'oneoff' && _this.donation.amount < 1) {
          _valid = false;
          _error_messages.push('Please enter an amount.');
        }

        if (_this.donation.type === 'recurring' && _this.donation.amount == 'other') {
          $('.js-payment-amount').attr('type', 'text').attr('placeholder', 'type to enter an amount');
        }

        if (_valid === true) {
          this._pay();
        } else {
          var arrayLength = _error_messages.length;
          for (var i = 0; i < arrayLength; i++) {
            $('.js-error').append('<p>' + _error_messages[i] + '</p>').addClass('on').attr('role', 'status');
          }

          $('.js-payment-method').css('display', 'none').attr('aria-hidden', 'true');
        }
      }
    }, {
      key: "_pay",
      value: function _pay() {
        var _this = this;

        $('.js-payment-method').css('display', 'none').attr('aria-hidden', 'true');
        $('.js-donation-payment').addClass('selected');

        var formSelectors = {
          UK_PayPal: {
            oneoff: '.js-onetime-paypal',
            recurring: '.js-recurring-paypal'
          },
          UK_Wire: '.js-uk-wire',
          UK_Cheque: '.js-uk-cheque',
          US_PayPal: {
            oneoff: '.js-onetime-paypal-us',
            recurring: '.js-recurring-paypal-us'
          },
          US_Wire: '.js-us-wire',
          US_Cheque: '.js-us-check'
        };

        var formSelector = false,
            donationMethod = _this.donation.payment_method,
            donationType = _this.donation.type,
            formTitle = donationMethod.indexOf('Cheque') > -1 ? "Cheque" : "Wire transfer";

        $('.payment-type-hidden').val(formTitle);
        $('.js-form-title').text(formTitle);

        if (donationMethod == 'UK_PayPal' || donationMethod == 'US_PayPal') {
          formSelector = formSelectors[donationMethod][donationType];
          _this._paypalSubmit(formSelector);
        } else {
          formSelector = formSelectors[donationMethod];

          if (!this.isBoundPaymentSubmit) {
            _this._paymentSubmit();
            this.isBoundPaymentSubmit = true;
          }
        }

        if (formSelector) {
          $(formSelector).css('display', 'block').attr('aria-hidden', 'false');
        }
      }
    }, {
      key: "_validateGiftAid",
      value: function _validateGiftAid(form) {
        var isCheckedGiftAid = false;

        form.find('[name="gift-aid"]').each(function () {
          if ($(this).prop('checked') == false) {
            isCheckedGiftAid = false;
          } else {
            isCheckedGiftAid = true;
            return false;
          }
        });

        if (!isCheckedGiftAid) {
          $('.js-gift-aid-error').css('display', 'inline-block').attr('aria-hidden', 'false');
          return false;
        } else {
          $('.js-gift-aid-error').hide().attr('aria-hidden', 'true');
          return true;
        }
      }
    }, {
      key: "_paypalSubmit",
      value: function _paypalSubmit(selector) {
        var _this = this,
            form = $(selector);
        var isReSubmitted = false,
            isSubmitted = false;

        form.submit(function (event) {
          var checkboxaccept = $(this).find('.js-checkbox'),
              requiredFields = $(this).find('.required'),
              isRecurringDonation = selector === '.js-recurring-paypal' || selector === '.js-recurring-paypal-us';

          var isValidForm = true;

          if (form.hasClass('prevented')) {
            event.preventDefault();
            form.removeClass('prevented');
          }

          form.find('.js-paypal-error').css('display', 'none').attr('role', '');

          if (isRecurringDonation && checkboxaccept.prop('checked') === false) {
            isValidForm = false;
            $(this).find('.js-paypal-error').css('display', 'inline-block').attr('role', 'status');
          }

          if (_this.donation.currency == 'GBP') {
            isValidForm = _this._validateGiftAid(form);
          }

          requiredFields.each(function () {
            var field = $(this),
                errorMessage = field.next('.form-error');

            if (field.val() == "") {
              isValidForm = false;
              errorMessage.css('display', 'inline-block').attr('aria-hidden', 'false');
            } else {
              errorMessage.hide().attr('aria-hidden', 'true');
            }
          });

          if (!isValidForm) {
            event.preventDefault();
          } else {
            var ajaxURL = MyAjax.ajaxurl,
                data = form.serialize(),
                payPalUrl = form.data('paypal');

            if (!isSubmitted) {
              $.ajax({
                type: 'POST',
                url: ajaxURL,
                data: data,
                success: function success(response) {
                  form.attr('action', payPalUrl);

                  if (!isReSubmitted) {
                    form.submit();
                    isReSubmitted = true;
                  }
                }
              });

              isSubmitted = true;
            }
          }
        });
      }
    }, {
      key: "_paymentSubmit",
      value: function _paymentSubmit() {

        var _this = this,
            form = $('.wiretransfer').find('form');

        form.submit(function (event) {
          event.preventDefault();

          var valid = true;

          // force user to check or uncheck Gift Aid
          if (_this.donation.currency == 'GBP') {
            valid = _this._validateGiftAid(form);
          }

          // check required fields within primary fields
          form.find(".required").each(function () {
            var requiredField = $(this),
                errorMessage = requiredField.next('.form-error');

            // if empty
            if (requiredField.val() == "") {

              errorMessage.css('display', 'inline-block');
              valid = false;
            } else {
              errorMessage.hide();
            }

            // if email - not working
            if (requiredField.attr('type') === 'email' && !_this._isValidEmailAddress(requiredField.val())) {
              requiredField.next('.form-error').css('display', 'inline-block');
              valid = false;
            }
          });

          if (valid) {
            var ajaxURL = MyAjax.ajaxurl;
            var data = form.serialize();

            $.ajax({
              type: 'POST',
              url: ajaxURL,
              data: data,
              success: function success(response) {
                form.find('.donation__success').css('display', 'block').attr('aria-hidden', 'false');
                form.find('input, select, textarea').each(function () {

                  if (!$(this).attr('readonly')) {
                    $(this).val("");
                  }
                });
              }
            });
          }
        });
      }
    }, {
      key: "_isValidEmailAddress",
      value: function _isValidEmailAddress(emailAddress) {
        var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
        return pattern.test(emailAddress);
      }
    }]);

    return _Donation;
  }();

  window.GunnerApp = GunnerApp;
})(undefined, jQuery);

GunnerApp.invoke = function () {
  var nodes = document.querySelectorAll('[data-gunner-js]'),
      node,
      func;

  for (var i = 0, j = nodes.length; i < j; i++) {
    node = nodes[i];
    func = node.getAttribute('data-gunner-js');
    if (this[func]) {
      console.log('fired ' + func);
      this[func](node);
    }
  }
};

// Utilities


function throttle(callback, limit) {
  var wait = false; // Initially, we're not waiting
  return function () {
    // We return a throttled function
    if (!wait) {
      // If we're not waiting
      callback.call(); // Execute users function
      wait = true; // Prevent future invocations
      setTimeout(function () {
        // After a period of time
        wait = false; // And allow future invocations
      }, limit);
    }
  };
}

function debounce(func, wait, immediate) {
  var timeout;

  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function guid() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

jQuery(document).on('ready', function () {
  GunnerApp.invoke();

  jQuery('.input__field').on('blur', function () {
    if (!jQuery(this).val()) {
      jQuery(this).parent('span').parent('.input').removeClass('input--focus');
    }
  }).on('focus', function () {
    jQuery(this).parent('span').parent('.input').addClass('input--focus');
  });
});

(function (root, $, undefined) {
  "use strict";

  $(".pagemenu__overlay").bind('touchstart', function (e) {
    if (e.target === this) {
      e.preventDefault();
      $('.pagemenu__item').removeClass('pagemenu__item--hover');
      $(this).parent('.pagemenu__item').addClass('pagemenu__item--hover');
    }
  });

  var cloneIndex = 2;

  $(".js-add-pax").click(function () {

    $(".passenger-entry-1").last().clone().appendTo($(".js-fields")).removeClass('passenger-entry-1').addClass('passenger-entry-' + cloneIndex).find("input").each(function () {
      var name = $(this).attr('name');
      $(this).val('');
    });

    cloneIndex++;
    return false;
  });

  // $(".js-remove-pax").click(function(e) {
  //   console.log('yes?');
  //   e.preventDefault();
  // });


  /**
   * Donate Form (Stripe)
   * on key up of input, update the adjusted amount by +25%
   */
  // Return number formatted with commas.
  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  var donationInput = $('.js-donation-input'),
      donationAmount = $('.js-donation-amount'),
      adjustedDonationAmount = $('.js-donation-adjusted-amount');

  donationInput.on('keyup', function (e) {
    var currentValue = donationInput[0].value.replace(/[^0-9.]/g, ''),
        adjustedCurrentValue = parseFloat(currentValue * 1.25, 10).toFixed(2);

    // If it's blank or 0, update the text fields below.
    // NOTE: Could potentially offer different message instead of showing zero's.
    if (currentValue == '' || currentValue == '0') {
      donationAmount.text('00.00');
      adjustedDonationAmount.text('00.00');
      return;
    }
    donationAmount.text(formatNumber(currentValue));
    adjustedDonationAmount.text(formatNumber(adjustedCurrentValue));
  });

  $('.js-passport-upload').on('change', function (e) {
    var value = $(this).val();
    var $parent = $(this).closest('.js-passenger-fields').find('.js-passport-fields');
    if (value) {
      $parent.find('.data-input').removeAttr('required');
    } else {
      $parent.find('.data-input').addAttr('required');
    }
  });

  $(".js-booking-request").on('submit', function (e) {

    var ajaxURL = MyAjax.ajaxurl;
    var $this = $(this);
    var data = $this.serialize();
    var data = new FormData(document.getElementById("bookingForm"));

    $this.find('.js-submit').prop("disabled", true);

    $.ajax({
      type: 'POST',
      url: ajaxURL,
      data: data,
      processData: false,
      contentType: false,
      enctype: 'multipart/form-data',
      success: function success(response) {

        if (response == 1) {
          $this.removeClass('form--fail').addClass('form--success');
          $('.js-message').empty().addClass('message').append('<p>Thank you for submitting your booking form. We will be in touch with you to confirm that we have received it.</p>');
        } else {
          var jsonData = JSON.parse(response);
          $('.js-message').empty();
          $.each(jsonData, function () {
            var message = this;
            $('.js-message').addClass('message').empty().append('<p>' + message + '</p>');
          });

          $this.find('.js-submit').prop("disabled", false);
          $this.removeClass('form--success').addClass('form--fail');
        }
        return false;
      }
    });

    e.preventDefault();
  });

  $(".js-brochure-request").on('submit', function (e) {

    var brochure_email = $(this).find('#brochureemail').val();
    var ajaxURL = MyAjax.ajaxurl;
    var $this = $(this);

    var data = {
      action: "brochure_request",
      toemail: brochure_email
    };

    console.log("Brochure request submitted");
    console.log(ajaxURL);
    console.log(data);

    $.ajax({
      type: 'POST',
      url: ajaxURL,
      data: data,
      success: function success(response) {
        if (response === 1) {
          $this.removeClass('form--success').addClass('form--fail');
        } else {
          $this.removeClass('form--fail').addClass('form--success');
        }
        return false;
      }
    });

    e.preventDefault();
  });

  $('.js-page-hero-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: true,
    speed: 500,
    autoplay: true
  });

  $('.js-page-hero-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var contentToHide = $('.js-hero-content-to-hide');

    // Hide the inner content if we're not on initial slide.
    if (nextSlide > 0) {
      contentToHide.addClass('inner--hidden');
    } else {
      contentToHide.removeClass('inner--hidden');
    }
  });
})(undefined, jQuery);